import { USER_PRIVACY_FOLLOWERS, USER_PRIVACY_NONE } from '@config/options.js'
import usePermissions from '@composables/usePermissions.js'
import { userStore, gameStore, authStore } from '@stores'
import { areBitsSet } from '@helpers/utils.js'
import { computed, unref } from 'vue'
import { useI18n } from 'vue-i18n'

const UPPERCASE_UGC_NAMES = ['UGC', 'UGX']

export default function () {
  const { user: myUser } = authStore()
  const { getPublicGame } = gameStore()
  const { getUser } = userStore()

  function canViewUserProfile(userNameId, followsRef) {
    return computed(() => {
      const user = getUser(userNameId)

      if (
        myUser.value?.name_id === userNameId ||
        usePermissions().isGameModerator.value
      )
        return true

      if (areBitsSet(user.value?.privacy_options, USER_PRIVACY_NONE))
        return false

      if (
        areBitsSet(user.value?.privacy_options, USER_PRIVACY_FOLLOWERS) &&
        !followsRef?.value?.data?.some(
          (f) => f.name_id === myUser.value?.name_id
        )
      )
        return false

      return true
    })
  }

  function ugcName(game, singular, lower) {
    return computed(() => {
      let _game = unref(game)

      if (!_game) {
        _game = getPublicGame().value
      }

      let _ugcName = _game?.ugc_name || 'Mods'
      if (singular) {
        _ugcName = _game?.ugc_name_single || _ugcName.replace(/s$/, '')
      }

      if (lower && !UPPERCASE_UGC_NAMES.includes(_ugcName)) {
        _ugcName = _ugcName.toLowerCase()
      }

      return _ugcName
    })
  }

  function tokenName(earnable = false) {
    const { t } = useI18n()
    return computed(() =>
      earnable
        ? t('credits')
        : getPublicGame().value?.token_name || t('currency')
    )
  }

  return {
    canViewUserProfile,
    tokenName,
    ugcName,
  }
}
